import { useCompleteToolCalibrationMutation } from "@common/api/tools"
import { handleError } from "@common/utils"
import { createFileRoute } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import {
  ActionCard,
  useCloseTo,
} from "@/routes/_layout/tools/-components/action-card"
import {
  CalibrationEntryFields,
  useCalibrationDraft,
} from "@/routes/_layout/tools/-components/calibration-entry"

export const Route = createFileRoute(
  "/_layout/tools/$toolId/calibrations/$calibrationId/complete",
)({
  component: CompleteCalibration,
})

function CompleteCalibration(): React.ReactElement {
  const { toolId, calibrationId } = Route.useParams()
  const showToast = useCustomToast()
  const mutation = useCompleteToolCalibrationMutation()
  const { draft, update } = useCalibrationDraft()
  const close = useCloseTo()

  const complete = () =>
    mutation.mutate(
      {
        tool_id: toolId,
        calibration_id: calibrationId,
        toolCalibrationComplete: {
          performed_on: draft.performedOn,
          result: draft.result,
          certificate_number: draft.certificateNumber.trim() || null,
          certificate_document_id: draft.certificate?.id ?? null,
        },
      },
      {
        onSuccess: (tool) => {
          showToast(
            "Recorded",
            `${tool.number} is back from calibration.`,
            "success",
          )
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ActionCard
      title="Record calibration return"
      confirmLabel="Record return"
      ready={Boolean(draft.performedOn)}
      pending={mutation.isPending}
      onCancel={close}
      onConfirm={complete}
    >
      <CalibrationEntryFields
        draft={draft}
        update={update}
        withPerformer={false}
      />
    </ActionCard>
  )
}
